/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_W2Inputs */

const en_mk_cmp_clickup_w2 = /** @type {(inputs: Mk_Cmp_Clickup_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have someone ready to configure and maintain it.`)
};

const id_mk_cmp_clickup_w2 = /** @type {(inputs: Mk_Cmp_Clickup_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda punya orang yang siap menata dan merawat konfigurasinya.`)
};

/**
* | output |
* | --- |
* | "You have someone ready to configure and maintain it." |
*
* @param {Mk_Cmp_Clickup_W2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_w2 = /** @type {((inputs?: Mk_Cmp_Clickup_W2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_W2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_w2(inputs)
	return en_mk_cmp_clickup_w2(inputs)
});